import React from "react";

/** Row of KPI cards. items: [{label, value, sub, level}] - items with value null are hidden. */
export default function KpiStrip({ items }) {
  const shown = items.filter((i) => i.value !== null && i.value !== undefined);
  return (
    <div className="ia-kpis">
      {shown.map((i) => (
        <div className="ia-card ia-kpi" key={i.label}>
          <div className="ia-kpi__label">{i.label}</div>
          <div className={`ia-kpi__value${i.level ? ` ia-text--${i.level}` : ""}`}>{i.value}</div>
          {i.sub ? <div className="ia-kpi__sub">{i.sub}</div> : null}
        </div>
      ))}
    </div>
  );
}
